/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UrlsRouteImport } from './routes/urls'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsApiRouteImport } from './routes/settings-api'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UrlsIndexRouteImport } from './routes/urls.index'
import { Route as UrlsIdRouteImport } from './routes/urls.$id'
import { Route as UrlsIdDiffChangeIdRouteImport } from './routes/urls.$id.diff.$changeId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UrlsRoute = UrlsRouteImport.update({
  id: '/urls',
  path: '/urls',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiRoute = SettingsApiRouteImport.update({
  id: '/settings-api',
  path: '/settings-api',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UrlsIndexRoute = UrlsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UrlsRoute,
} as any)
const UrlsIdRoute = UrlsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => UrlsRoute,
} as any)
const UrlsIdDiffChangeIdRoute = UrlsIdDiffChangeIdRouteImport.update({
  id: '/diff/$changeId',
  path: '/diff/$changeId',
  getParentRoute: () => UrlsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/settings-api': typeof SettingsApiRoute
  '/signup': typeof SignupRoute
  '/urls': typeof UrlsRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/urls/$id': typeof UrlsIdRouteWithChildren
  '/urls/': typeof UrlsIndexRoute
  '/urls/$id/diff/$changeId': typeof UrlsIdDiffChangeIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/settings-api': typeof SettingsApiRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/urls/$id': typeof UrlsIdRouteWithChildren
  '/urls': typeof UrlsIndexRoute
  '/urls/$id/diff/$changeId': typeof UrlsIdDiffChangeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/settings-api': typeof SettingsApiRoute
  '/signup': typeof SignupRoute
  '/urls': typeof UrlsRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/urls/$id': typeof UrlsIdRouteWithChildren
  '/urls/': typeof UrlsIndexRoute
  '/urls/$id/diff/$changeId': typeof UrlsIdDiffChangeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alerts'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/settings-api'
    | '/signup'
    | '/urls'
    | '/verify-email'
    | '/urls/$id'
    | '/urls/'
    | '/urls/$id/diff/$changeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/settings-api'
    | '/signup'
    | '/verify-email'
    | '/urls/$id'
    | '/urls'
    | '/urls/$id/diff/$changeId'
  id:
    | '__root__'
    | '/'
    | '/alerts'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/settings-api'
    | '/signup'
    | '/urls'
    | '/verify-email'
    | '/urls/$id'
    | '/urls/'
    | '/urls/$id/diff/$changeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertsRoute: typeof AlertsRoute
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  SettingsApiRoute: typeof SettingsApiRoute
  SignupRoute: typeof SignupRoute
  UrlsRoute: typeof UrlsRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/urls': {
      id: '/urls'
      path: '/urls'
      fullPath: '/urls'
      preLoaderRoute: typeof UrlsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings-api': {
      id: '/settings-api'
      path: '/settings-api'
      fullPath: '/settings-api'
      preLoaderRoute: typeof SettingsApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/urls/': {
      id: '/urls/'
      path: '/'
      fullPath: '/urls/'
      preLoaderRoute: typeof UrlsIndexRouteImport
      parentRoute: typeof UrlsRoute
    }
    '/urls/$id': {
      id: '/urls/$id'
      path: '/$id'
      fullPath: '/urls/$id'
      preLoaderRoute: typeof UrlsIdRouteImport
      parentRoute: typeof UrlsRoute
    }
    '/urls/$id/diff/$changeId': {
      id: '/urls/$id/diff/$changeId'
      path: '/diff/$changeId'
      fullPath: '/urls/$id/diff/$changeId'
      preLoaderRoute: typeof UrlsIdDiffChangeIdRouteImport
      parentRoute: typeof UrlsIdRoute
    }
  }
}

interface UrlsIdRouteChildren {
  UrlsIdDiffChangeIdRoute: typeof UrlsIdDiffChangeIdRoute
}

const UrlsIdRouteChildren: UrlsIdRouteChildren = {
  UrlsIdDiffChangeIdRoute: UrlsIdDiffChangeIdRoute,
}

const UrlsIdRouteWithChildren =
  UrlsIdRoute._addFileChildren(UrlsIdRouteChildren)

interface UrlsRouteChildren {
  UrlsIdRoute: typeof UrlsIdRouteWithChildren
  UrlsIndexRoute: typeof UrlsIndexRoute
}

const UrlsRouteChildren: UrlsRouteChildren = {
  UrlsIdRoute: UrlsIdRouteWithChildren,
  UrlsIndexRoute: UrlsIndexRoute,
}

const UrlsRouteWithChildren = UrlsRoute._addFileChildren(UrlsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertsRoute: AlertsRoute,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  SettingsApiRoute: SettingsApiRoute,
  SignupRoute: SignupRoute,
  UrlsRoute: UrlsRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
